import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import DashboardLayout from "@/components/feature/DashboardLayout";
import ProtectedRoute from "@/components/feature/ProtectedRoute";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/auth/login/page";
import RegisterPage from "@/pages/auth/register/page";
import ForgotPasswordPage from "@/pages/auth/forgot-password/page";
import HomePage from "@/pages/dashboard/home/page";
import OrdersPage from "@/pages/dashboard/orders/page";
import ItemsPage from "@/pages/dashboard/items/page";
import DriversPage from "@/pages/dashboard/drivers/page";
import DriverDetailPage from "@/pages/dashboard/drivers/detail/page";
import OrderDetailPage from "@/pages/dashboard/orders/detail/page";
import FinancePage from "@/pages/dashboard/finance/page";
import SettlementDetailPage from "@/pages/dashboard/finance/settlement/page";
import ReviewsPage from "@/pages/dashboard/reviews/page";
import DriverReviewsDetailPage from "@/pages/dashboard/reviews/driver/page";
import NotificationsPage from "@/pages/dashboard/notifications/page";
import SettingsPage from "@/pages/dashboard/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          {
            path: "/dashboard",
            element: <HomePage />,
          },
          {
            path: "/dashboard/orders",
            element: <OrdersPage />,
          },
          {
            path: "/dashboard/orders/:orderId",
            element: <OrderDetailPage />,
          },
          {
            path: "/dashboard/items",
            element: <ItemsPage />,
          },
          {
            path: "/dashboard/drivers",
            element: <DriversPage />,
          },
          {
            path: "/dashboard/drivers/:driverId",
            element: <DriverDetailPage />,
          },
          {
            path: "/dashboard/finance",
            element: <FinancePage />,
          },
          {
            path: "/dashboard/finance/settlements/:settlementId",
            element: <SettlementDetailPage />,
          },
          {
            path: "/dashboard/reviews",
            element: <ReviewsPage />,
          },
          {
            path: "/dashboard/reviews/drivers/:driverId",
            element: <DriverReviewsDetailPage />,
          },
          {
            path: "/dashboard/notifications",
            element: <NotificationsPage />,
          },
          {
            path: "/dashboard/settings",
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;